import { Box } from '@mui/material'
import { CommentEmptyState } from '@omnea-app/fe-requests/CommentEmptyState'

type EmptyMentionListProps = {
  showResolved: boolean
}

export const EmptyMentionList = ({ showResolved }: EmptyMentionListProps) => {
  return (
    <Box
      sx={{
        bgcolor: 'neutralLight.0',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'neutralLight.300',
        p: 3,
      }}
    >
      <CommentEmptyState
        commentSource={`dashboard-mentions-${showResolved ? 'resolved' : 'unresolved'}`}
        commentsVisibility="internal"
      />
    </Box>
  )
}
